import { ConfigService } from '../_service/config.service';
import { firstValueFrom } from 'rxjs';

export function appInitializer(configService: ConfigService) {
  return () => firstValueFrom(configService.loadConfig());
}